export default {
  windowsSize: ({ re_size }) => re_size,
  isOpen: ({ is_open }) => is_open,
};
